/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SatisfactionSurvey = {
    properties: {
        id: {
    type: 'number',
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        formId: {
    type: 'number',
    isRequired: true,
},
        roomId: {
    type: 'number',
    isRequired: true,
},
        resident: {
    type: 'string',
    isRequired: true,
},
        completedBy: {
    type: 'string',
    isRequired: true,
},
        physician: {
    type: 'string',
},
        admissionDate: {
    type: 'string',
},
    },
};